import { ref, onMounted, onUnmounted } from 'vue'

export function useInViewport(targetRef, options = {}) {
	const isIntersecting = ref(false)

	let observer = null

	const observe = () => {
		if (!targetRef.value) return

		observer = new IntersectionObserver(
			([entry]) => {
				isIntersecting.value = entry.isIntersecting
			},
			{
				threshold: 0.1,
				...options,
			}
		)

		observer.observe(targetRef.value)
	}

	onMounted(() => {
		observe()
	})

	onUnmounted(() => {
		if (observer && targetRef.value) {
			observer.unobserve(targetRef.value)
		}
	})

	return {
		isIntersecting,
	}
}
